export const envParameters = {
  webUrl: process.env.NEXT_PUBLIC_FRONTEND_URL,
  baseApiUrl: process.env.NEXT_PUBLIC_VIALMA_API_URL,
  superTokensApiUrl: process.env.NEXT_PUBLIC_VIALMA_SUPERTOKENS_API_URL,
};
